import React from 'react';
import {Box, Stack} from '@mui/material';
import './SearchList.scss';
import {SessionSearch} from '../types/SessionSearch';
import SearchListItem from './search-list-item/SearchListItem';

export interface SearchListProps {
  items: SessionSearch[];
  canPin?: boolean;
  onItemSelected?: (index: number, item: SessionSearch) => void;
  onItemPinned?: (index: number, item: SessionSearch) => void;
  onItemUnpinned?: (index: number, item: SessionSearch) => void;
  onItemDeleted?: (index: number, item: SessionSearch) => void;
}

const SearchList: React.FC<SearchListProps> = ({
  items,
  canPin,
  onItemSelected,
  onItemPinned,
  onItemUnpinned,
  onItemDeleted,
}) => {
  return (
    <Box className="session-search-list" role="list">
      <Stack spacing={1}>
        {items &&
          items.map((item, index) => {
            return (
              <SearchListItem
                key={index}
                index={index}
                item={item}
                canPin={canPin}
                onSelect={onItemSelected}
                onPin={onItemPinned}
                onUnpin={onItemUnpinned}
                onDelete={onItemDeleted}
              />
            );
          })}
      </Stack>
    </Box>
  );
};
export default SearchList;
